import { setAuthToken } from './authToken'

import { api, apiWithRetry, unwrapApiResult } from './api'
import { parseUserModel, UserInterface, UserResponseInterface } from '../models/UserModel'

export interface LoginPayload {
  username: string
  password: string
}

export interface LoginWithPinPayload {
  username: string
  pin: string
}

export interface LoginResponse {
  accessToken: string
}

export async function login(payload: LoginPayload) {
  const result = await api<LoginResponse>({
    method: 'POST',
    url: '/login',
    data: payload,
  })

  if (result.ok) {
    await setAuthToken(result?.data?.accessToken || null)
  }

  return result
}

export async function loginWithPin(payload: LoginWithPinPayload) {
  const result = await api<LoginResponse>({
    method: 'POST',
    url: '/login/pin',
    data: payload,
  })

  if (result.ok) {
    await setAuthToken(result?.data?.accessToken || null)
  }

  return result
}

export async function getMe(): Promise<UserInterface> {
  const result = await apiWithRetry<UserResponseInterface>(
    {
      method: 'GET',
      url: '/me',
    },
    { retries: 2, baseDelayMs: 400, maxDelayMs: 2500 }
  )

  const data = unwrapApiResult(result)

  return parseUserModel(data)
}

export async function setPin(pin: string): Promise<void> {
  const result = await apiWithRetry(
    {
      method: 'POST',
      url: '/pin',
      data: {
        pin,
      },
    },
    { retries: 2, baseDelayMs: 400, maxDelayMs: 2500 }
  )

  unwrapApiResult(result)
}
